// extracted by mini-css-extract-plugin
export var active = "_2a-b";
export var activeIndicator = "_2a-6";
export var animate = "_2a-a";
export var disabled = "_2a-c";
export var flat = "_2a-1";
export var fullWidth = "_2a-3";
export var lg = "_2a-9";
export var md = "_2a-8";
export var redoButtonTabGroup = "_2a-0";
export var sm = "_2a-7";
export var tabButton = "_2a-4";
export var tabButtonsContainer = "_2a-2";
export var xs = "_2a-5";